import httpClient from "./httpClient";
import store from "@/store";

const entityEndpoint = "/enquiries";

export default {
  async getEnquiries() {
    const response = await httpClient.get(entityEndpoint, {
      params: {
        potential: store.state.enquiryFilter.potential,
        manager: store.state.enquiryFilter.manager,
        tour: store.state.enquiryFilter.tour,
        type: store.state.enquiryFilter.type,
        completed: store.state.enquiryFilter.completed,
        followup: store.state.enquiryFilter.followup
      }
    });

    return response.data;
  },

  async getEnquiry(id) {
    const response = await httpClient.get(`${entityEndpoint}/${id}`);
    return response.data;
  },

  async deleteEnquiry(id) {
    const response = await httpClient.delete(`${entityEndpoint}/${id}`);
    return response.data;
  },

  async createEnquiry(enquiry) {
    const response = await httpClient.post(entityEndpoint, {
      ...enquiry
    });
    return response.data;
  },

  async updateEnquiry(enquiry) {
    const response = await httpClient.put(`${entityEndpoint}/${enquiry.id}`, {
      ...enquiry
    });
    return response.data;
  },

  async reactivateEnquiry(enquiry) {
    const response = await httpClient.put(
      `${entityEndpoint}/outcome/${enquiry.id}/reactivate`
    );
    return response.data;
  },

  // Outcome
  async createOutcome(args) {
    const response = await httpClient.post(
      `${entityEndpoint}/outcome/${args.enquiry.id}`,
      {
        ...args.outcome
      }
    );
    return response.data;
  },

  // Interactions
  async createInteraction(args) {
    const response = await httpClient.post(
      `${entityEndpoint}/${args.enquiry.id}/interactions`,
      {
        ...args.interaction
      }
    );
    return response.data;
  },

  async updateInteraction(args) {
    const response = await httpClient.put(
      `${entityEndpoint}/${args.enquiry.id}/interactions/${args.interaction.id}`,
      {
        ...args.interaction
      }
    );
    return response.data;
  },

  async deleteInteraction(args) {
    const response = await httpClient.delete(
      `${entityEndpoint}/${args.enquiry.id}/interactions/${args.interaction.id}`
    );
    return response.data;
  },

  async getEnquiryFollowUps() {
    const response = await httpClient.get("/widgets/enquiry-followups");
    return response.data;
  },

  async getMonthlyEnquiryCount() {
    const response = await httpClient.get("/widgets/monthly-enquiry-count");
    return response.data;
  },

  async getEnquiryConversions() {
    const response = await httpClient.get("/widgets/enquiry-conversions");
    return response.data;
  }
};
